export class UserSettings {
  learningAutoAdjustLevel: boolean;
  isAutoPronunciation: boolean;

  constructor(learningAutoAdjustLevel: boolean, isAutoPronunciation: boolean) {
    this.learningAutoAdjustLevel = learningAutoAdjustLevel;
    this.isAutoPronunciation = isAutoPronunciation;
  }
}
